export default __webpack_public_path__ + "static/media/adiel.b1f83206.jpg";